import { useTranslate } from 'hooks/useTranslate';

const DocumentsListHeader = () => {
  const { t } = useTranslate();

  return (
    <div className="nk-files-head">
      <div className="nk-file-item">
        <div className="nk-file-info">
          <div className="tb-head ml-4">{t('Name')}</div>
        </div>

        <div className="nk-file-meta d-none d-xl-table-cell text-center">
          <div className="tb-head">{t('DocumentDate')}</div>
        </div>
      </div>
    </div>
  );
};

export default DocumentsListHeader;
